import React, { useEffect, useRef, useState } from "react";

const STATS = [
    { value: 2400, suffix: "+", label: "Бізнесів використовують AutoAds" },
    { value: 3.2, prefix: "€", suffix: "M", label: "Рекламних бюджетів проаналізовано", decimals: 1 },
    { value: 2.8, suffix: "×", label: "Середнє покращення CPA", decimals: 1 },
    { value: 18400, suffix: "+", label: "Кампаній оптимізовано" },
];

const Counter = ({ value, prefix = "", suffix = "", decimals = 0 }) => {
    const [n, setN] = useState(0);
    const ref = useRef(null);
    const started = useRef(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const obs = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && !started.current) {
                    started.current = true;
                    const duration = 1800;
                    const start = performance.now();
                    const step = (now) => {
                        const t = Math.min(1, (now - start) / duration);
                        const ease = 1 - Math.pow(1 - t, 3);
                        setN(value * ease);
                        if (t < 1) requestAnimationFrame(step);
                    };
                    requestAnimationFrame(step);
                }
            },
            { threshold: 0.4 }
        );
        obs.observe(el);
        return () => obs.disconnect();
    }, [value]);

    const formatted =
        decimals > 0
            ? n.toFixed(decimals)
            : Math.floor(n).toLocaleString("uk-UA");

    return (
        <span ref={ref} className="font-mono font-bold text-text-primary tabular-nums" style={{ fontSize: "clamp(34px, 5vw, 52px)", letterSpacing: "-0.02em" }}>
            {prefix}{formatted}{suffix}
        </span>
    );
};

export const LiveNumbers = () => {
    return (
        <section
            data-testid="live-numbers"
            className="relative py-20 border-y border-border bg-surface/40"
        >
            <div className="container-mx">
                <div className="grid grid-cols-2 md:grid-cols-7 items-stretch gap-y-10">
                    {STATS.map((s, i) => (
                        <React.Fragment key={i}>
                            <div className="md:col-span-1 text-center md:text-left">
                                <Counter {...s} />
                                <div className="mt-3 text-xs md:text-sm text-secondary-c leading-tight max-w-[180px] mx-auto md:mx-0">
                                    {s.label}
                                </div>
                            </div>
                            {i < STATS.length - 1 && <div className="hidden md:block stat-divider" />}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default LiveNumbers;
